// Plugin to install auth globally in vue
import { Auth } from "./main.js";

export const CognitoAuthPlugin = {
  install(Vue, options) {
    Vue.CognitoAuth = new Auth(options.config);
  }
};
